import CustomUIFontStyle from './CustomUIFontStyle'
import CustomUIImageStyle from './CustomUIImageStyle'
import CustomUIGoodItem from './CustomUIGoodItem'
import { FileReader, FileWriter } from '@/platform'

class CustomUIGood {
  public Width: number = 0 // 商品区域宽
  public Height: number = 0 // 商品区域高
  public G_x: number = 0 // 商品区域X坐标
  public G_y: number = 0 // 商品区域Y坐标
  public D_x: number = 0 // 商品区域行间距
  public D_y: number = 0 // 商品区域列间距
  public G_count: number = 0 // 商品个数
  public BuyImagePath: string = '' // 购买图片路径
  public BuyedImagePath: string = '' // 已购买图片路径
  public BuyBtnIndex: number = 0 // 购买按钮图片索引值
  public CloseBtnIndex: number = 0 // 关闭按钮图片索引值
  public CloseIndex: number = 0 // 关闭索引值
  public TipsOkBtnIndex: number = 0 // 确定按钮索引
  public KongIndex: number = 0 // 空按钮图片索引值
  public FlowerIndex: number = 0 // 剩余鲜花变量
  public FlowerExIndex: number = 0 // 已花费鲜花二周目索引
  public TipsUIIndex: number = 0 // 剩余鲜花高级UI序号
  public Flower: CustomUIFontStyle = new CustomUIFontStyle() // 剩余鲜花文字图片
  public BgImage: CustomUIImageStyle = new CustomUIImageStyle() // 底图
  public CloseImage: CustomUIImageStyle = new CustomUIImageStyle() // 关闭按钮图
  public TipsF: CustomUIImageStyle = new CustomUIImageStyle() // 鲜花不足预览图
  public TipsOk: CustomUIImageStyle = new CustomUIImageStyle() // 确定
  public GoodList: CustomUIGoodItem[] = [] // 商品集合

  readBin(reader: FileReader): void {
    this.Width = reader.readInt()
    this.Height = reader.readInt()
    this.G_x = reader.readInt()
    this.G_y = reader.readInt()
    this.D_x = reader.readInt()
    this.D_y = reader.readInt()
    this.G_count = reader.readInt()
    this.BuyImagePath = reader.readString()
    this.BuyedImagePath = reader.readString()
    this.BuyBtnIndex = reader.readInt()
    this.CloseBtnIndex = reader.readInt()
    this.CloseIndex = reader.readInt()
    this.TipsOkBtnIndex = reader.readInt()
    this.KongIndex = reader.readInt()
    this.FlowerIndex = reader.readInt()
    this.FlowerExIndex = reader.readInt()
    this.TipsUIIndex = reader.readInt()
    this.Flower = new CustomUIFontStyle(reader)
    this.BgImage = new CustomUIImageStyle(reader)
    this.CloseImage = new CustomUIImageStyle(reader)
    this.TipsF = new CustomUIImageStyle(reader)
    this.TipsOk = new CustomUIImageStyle(reader)
    this.GoodList = []
    const n = reader.readInt()
    this.GoodList.length = n
    for (let i = 0; i < n; i++) {
      const item = new CustomUIGoodItem(undefined)
      item.readBin(reader)
      this.GoodList[i] = item
    }
  }

  writeBin(writer: FileWriter): void {
    writer.writeInt(this.Width)
    writer.writeInt(this.Height)
    writer.writeInt(this.G_x)
    writer.writeInt(this.G_y)
    writer.writeInt(this.D_x)
    writer.writeInt(this.D_y)
    writer.writeInt(this.G_count)
    writer.writeString(this.BuyImagePath)
    writer.writeString(this.BuyedImagePath)
    writer.writeInt(this.BuyBtnIndex)
    writer.writeInt(this.CloseBtnIndex)
    writer.writeInt(this.CloseIndex)
    writer.writeInt(this.TipsOkBtnIndex)
    writer.writeInt(this.KongIndex)
    writer.writeInt(this.FlowerIndex)
    writer.writeInt(this.FlowerExIndex)
    writer.writeInt(this.TipsUIIndex)
    this.writeFontStyle(writer, this.Flower)
    this.BgImage.writeBin(writer)
    this.CloseImage.writeBin(writer)
    this.TipsF.writeBin(writer)
    this.TipsOk.writeBin(writer)
    writer.writeInt(this.GoodList.length)
    for (let i = 0; i < this.GoodList.length; i++) {
      this.GoodList[i]!.writeBin(writer)
    }
  }

  private writeFontStyle(writer: FileWriter, s: CustomUIFontStyle): void {
    writer.writeInt(s.FontSize)
    writer.writeString(s.FontName)
    writer.writeString(s.FontCor)
    writer.writeInt(s.X)
    writer.writeInt(s.Y)
  }
}

export default CustomUIGood
